import React from 'react';
import { VacationEnd, VacationStart } from "./VacationRange";
import { hasStoreUpcomingVacation } from "../../utils/dateUtils";

const VacationBadge = (props) => {
    const vacationStart = props.vacation_start ? new Date(props.vacation_start) : null;
    const vacationEnd = props.vacation_end ? new Date(props.vacation_end) : null;

    if (!hasStoreUpcomingVacation(vacationStart, vacationEnd)) {
        return '';
    }

    return (
        <span
            className="bg-accent-100 text-white font-exo font-medium inline-flex items-center justify-center text-center text-10 px-2 py-1 ml-2">
            <strong className="font-semibold">
                <VacationStart date={vacationStart} />
                {props.vacation_start !== props.vacation_end &&
                    <VacationEnd date={vacationEnd} />
                }
            </strong>
            &nbsp;
            {props.vacation_reason_short}
        </span>
    );
};

export default VacationBadge;
